module.exports = __webpack_public_path__ + "img/back rise.014c6c9b.png";